// extracted by mini-css-extract-plugin
export default {"bg":"bottomModal_bg__Siq2F","body":"bottomModal_body__nACGP","line":"bottomModal_line__T+oBe"};